import emRouteHelperMixin from "@/mixin/em/helper/route";

export const WITHOUT_ATTACHMENT_TAG = '__withoutAttachment';
export default {
    mixins: [emRouteHelperMixin],
    data() {
        return {
            VALUE_TYPE: {
                INPUT: 'input',
                ENTITY_ID: 'entity',
                SELECT: 'select',
                SELECT_MULTI: 'select-multi',
                RADIO_SELECT: 'radio-select',
                TEXTAREA: 'textarea',
                DATE: 'date',
                DATETIME: 'datetime',
                TABLE: 'table',
                RANGE: 'range',
                COLOR: 'color',
                CHECKBOX: 'checkbox',
                IMAGE: 'image',
                DATE_RANGE: 'date-range'
            },
            SAVE_TO: {
                DATABASE: 'database',
                FLOW: 'flowVariables',
                APPROVE: 'approve'
            },
            taskLocalVariables: {},
            taskLocalVariableInit: false
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        commentConfig() {
            return {
                label: '反馈意见',
                type: this.VALUE_TYPE.INPUT,
                require: false
            }
        },
        defaultApproveConfig() {
            return {
                label: '批复',
                type: this.VALUE_TYPE.SELECT,
                saveTo: this.SAVE_TO.APPROVE,
                options: [{value: 1, text: '是'}, {value: 2, text: '否'}]
            };
        },
        defaultTaskConfig() {
            return {
                variables: [],
                withAttachment: true,
                withComment: true,
            }
        },
        $_selfCompleteApi() {
            return `${this.$_emApiMixin_moduleBaseApi(this.modelName)}/${this.modelName}/completeTask`;
        },
        $_selfCompleteFeedbackApi() {
            return `${this.$_emApiMixin_moduleBaseApi(this.modelName)}/${this.modelName}/complete-feedback`;
        },
        $_defaultUndoFeedbackApi() {
            return `${this.$_emApiMixin_moduleBaseApi(this.modelName)}/${this.modelName}/workflow/undo-status-change`;
        },
        initializedConfig() {
            if (this.config) {
                return this.config;
            }
            let remoteConfig = this.getRemoteConfig();
            if (remoteConfig) {
                return remoteConfig;
            }
            return {};
        }
    },
    methods: {
        buildTag(name, value) {
            return {
                name: name,
                value: value
            }
        },
        setLocalVariables(items) {
            if (items !== undefined && items.length > 0) {
                this.taskLocalVariables = items[items.length - 1].taskLocalVariables;
                this.taskLocalVariableInit = true;
            }
            this.$refs['processComplete'] && this.$refs['processComplete'].setLocalVariables(items);
        },
        initConfig(config) {
            if (config === undefined) {
                config = this.defaultTaskConfig;
            }
            if (!config.hasOwnProperty('variables')) {
                config.variables = [];
            }
            if (config.hasOwnProperty('approveLabel')) {
                let hasApprove = false;
                for (let item of config.variables) {
                    if (item.saveTo === this.SAVE_TO.APPROVE) {
                        hasApprove = true;
                    }
                }
                if (!hasApprove) {
                    let temp = JSON.parse(JSON.stringify(this.defaultApproveConfig));
                    temp.label = config.approveLabel;
                    config.variables.splice(0, 0, temp);
                }
            }
            if (config.tag === undefined) {
                config.tag = {};
            }
            //处理variables里的repeat字段
            let tempList = [];
            let reBuild = false;//标记重建，用于维持顺序
            for (let item of config.variables) {
                //如果options里包含字符串项
                let options = item.options;
                if (options && options.length > 0) {
                    for (let i = 0; i < options.length; i++) {
                        if (typeof options[i] === 'string') {
                            item.options[i] = {
                                value: options[i],
                                text: options[i]
                            }
                        }
                    }
                }
                //如果存在repeat配置
                if (item.repeat && item.hasOwnProperty('labelWithName')) {
                    let tempItem = JSON.parse(JSON.stringify(item));
                    delete tempItem.labelWithName;
                    for (let name in item.labelWithName) {
                        if (item.labelWithName.hasOwnProperty(name)) {
                            tempItem.name = name;
                            tempItem.label = item.labelWithName[name];
                            tempList.push(JSON.parse(JSON.stringify(tempItem)));
                            reBuild = true;
                        }
                    }
                } else {
                    tempList.push(item);
                }
                if (item.saveTo === this.SAVE_TO.APPROVE && item.name === undefined) {
                    item.name = "origin_approved";
                }
            }
            if (reBuild) {
                config.variables = tempList;
            }

            this.commentConfig.require = config.withCommentNotNull;
            return config;
        },
        hasCode(value) {
            return value !== undefined && value != null && value !== '';
        },
        isType(type) {
            return this.config.type === type;
        },
        getTaskConfig(taskId) {
            return this.getTaskConfigOfExist(taskId, this.initializedConfig);
        },
        getTaskConfigOfExist(taskId, configs) {
            let temp = configs[taskId];
            if (temp === undefined) {
                let customTemp = configs['*'];
                if (customTemp) {
                    return customTemp;
                } else
                    return this.defaultTaskConfig;
            } else
                return temp;
        },
        //后端获取配置数据
        getRemoteConfig() {
            //todo query config form database
        }
    }
}
